import type { Option } from '@/modules/common/types/option.type.ts';

export type CounterpartyContactItem = {
  id: string;
  type: Option;
  contact: string;
  comment: string;
  fio: string;
  position: Option | null;
  birthDay: string | null;
  mask: string | null;
};

export type CounterpartyContactForm = {
  contacts: CounterpartyContactItem[];
};

export type CounterpartyContactFormData = {
  type: Option;
  contact: string;
  comment: string;
  fio: string;
  position: Option | null;
  birthDay: string | null;
  mask: string | null;
};

export function createEmptyContactForm(): CounterpartyContactForm {
  return {
    contacts: [],
  };
}

export function isPersonalContact(item: Pick<CounterpartyContactItem, 'fio' | 'position' | 'birthDay'>) {
  return Boolean(item.fio.trim() || item.position?.label.trim() || item.birthDay);
}
